declare const angular: ng.IAngularStatic;
export var browsCategoryComponent = {
  template: `
            <div class="card" layout="row" layout-align="space-around center">
                <div flex="30">

                    <md-autocomplete
                            md-selected-item="selectedItem"
                            md-search-text-change="searchTextChange(searchText)"
                            md-search-text="searchText"
                            md-selected-item-change="selectedItemChange(item)"
                            md-items="item in loadCategories(searchText)"
                            md-item-text="item.CategoryName"
                            md-min-length="0"
                            placeholder="فیلتر دسته بندی والد">
                        <md-item-template>
                            <span md-highlight-text="searchText" md-highlight-flags="^i">{{item.CategoryName}}</span>
                        </md-item-template>
                        <md-not-found>
                            هیچ موردی برای "{{searchText}}" یافت نشد.
                        </md-not-found>
                    </md-autocomplete>
                </div>
                <div flex="30">
                    <md-input-container  class="md-icon-float md-icon-right  md-block">
                        <label>جستجو در نام دسته بندی</label>
                        <input name="name" type="text" ng-model="filters.CategoryName" ng-change="changeFilter()" />
                        <md-icon aria-label="label" ><i class="fa fa-search"></i></md-icon>
                    </md-input-container>
                </div>
            </div>
            <div class="card-panel spn-gridList">
                <ul class="header">
                    <li layout="row" layout-align="start center">
                        <span flex="5" ng-if="$ctrl.multiSelect"><md-checkbox class="md-primary" name="name" ng-model="masterCheckbox" ng-change="checkOrUncheckAll(masterCheckbox)" ng aria-label="label"></md-checkbox></span>
                        
                       <span flex="10" ng-if="!$ctrl.multiSelect">انتخاب</span>

                        <span flex="95">عنوان</span>
                    </li>
                </ul>
                <ul class="body">
                    <spn-loading ng-if="categoryQuery.AjaxLoading || !categoryQuery"></spn-loading>
                    <li layout="row" layout-align="start center" ng-repeat="category in categoryQuery.Data">
                        
                        <span flex="5" ng-if="$ctrl.multiSelect"><md-checkbox class="md-primary" name="name" ng-model="BrowsModel[category.CategoryID].isChecked" ng-change="changeCheck(category)" aria-label="label"></md-checkbox></span>

                         <span ng-if="!$ctrl.multiSelect" flex="10" class="singleSelect">
                            <md-button style ng-click="selectOne(category)">انتخاب</md-button>   
                        </span>

                        <span flex="95">{{category.CategoryName}}</span>
                    </li>
                    <li layout="row" layout-align="start center" ng-if="categoryQuery.TotalCount === 0">
                        <span flex="100" class="text-center">موردی یافت نشد.</span>
                    </li>
                </ul>
                <ul class="footer">
                    <li layout="row" layout-align="start center">
                        <span flex="50" layout="row" layout-align="start center" style="padding-right: 40px">
                           
                            <pagination page-change="change(pageNumber)" self-page-change="true" page-number="categoryQuery.PageNumber" page-size="categoryQuery.PageSize"
                            total-items="categoryQuery.TotalCount"></pagination>
                        </span>
                        <span flex="50" layout="row" layout-align="end center" style="padding-left: 40px">
                            <md-select ng-change="change()" flex="20" ng-model="categoryQuery.PageSize">
                                <md-option ng-repeat="state in [10,15,20,50,100]" ng-value="state" >
                                    {{state}}
                                </md-option>
                            </md-select>
                            مورد در صفحه
                        </span>
                    </li>
                </ul>
            </div>
            <div ng-if="$ctrl.multiSelect" class="mt-10" layout="row" layout-align="center center">
                <md-button class="md-raised md-primary" ng-click="save()" aria-label="label">ذخیره</md-button>
            </div>
            <div ng-if="!$ctrl.multiSelect" class="mt-10" layout="row" layout-align="center center">
                <md-button class="md-raised md-primary" ng-click="cancel()" aria-label="label">انصراف</md-button>
            </div>
        `,
  controller: CategoryComponentController,
  bindings: {
    onSave: '&',
    onCancel: '&',
    multiSelect: '=multiSelect'
  }
};
function CategoryComponentController(
  $scope,
  $Category,
  $timeout,
  $http,
  MyConstant
) {
  'ngInject';

  var ctrl = this;

  $scope.BrowsModel = {};

  $scope.categoryQuery = $Category.query();

  $scope.checkOrUncheckAll = masterCheckbox => {
    $scope.categoryQuery.Data.map(item => {
      if (masterCheckbox) {
        item.isChecked = true;
        $scope.BrowsModel[item.CategoryID] = item;
      } else {
        delete $scope.BrowsModel[item.CategoryID];
      }
    });
  };

  $scope.changeCheck = item => {
    if ($scope.BrowsModel[item.CategoryID].isChecked) {
      item.isChecked = true;
      $scope.BrowsModel[item.CategoryID] = item;
    } else {
      delete $scope.BrowsModel[item.CategoryID];
    }
  };

  var changeFilterTimeout;
  $scope.changeFilter = () => {
    $scope.masterCheckbox = null;
    $timeout.cancel(changeFilterTimeout);
    $scope.categoryQuery.AjaxLoading = true;
    changeFilterTimeout = $timeout(() => {
      var filters = [];
      angular.forEach($scope.filters, (val, key) => {
        var item = { Property: key, Value: val };
        filters.push(item);
      });
      $scope.categoryQuery.Filters = JSON.stringify(filters);
      $scope.categoryQuery.$query();
    }, 300);
  };
  $scope.change = pageNumber => {
    $scope.categoryQuery.PageNumber = pageNumber;
    $scope.masterCheckbox = null;
    var filters = [];
    angular.forEach($scope.filters, (val, key) => {
      var item = { Property: key, Value: val };
      filters.push(item);
    });
    $scope.categoryQuery.Filters = JSON.stringify(filters);
    $scope.categoryQuery.AjaxLoading = true;
    $scope.categoryQuery.$query();
  };

  $scope.selectedItemChange = item => {
    $scope.filters = $scope.filters || {};
    if (item) {
      $scope.filters.ParentCategoryID = item.CategoryID;
    } else {
      delete $scope.filters.ParentCategoryID;
    }
    $scope.changeFilter();
  };

  $scope.loadCategories = searchText => {
    if (searchText) {
      return $http
        .get(
          `${
            MyConstant.ApiUrl
          }product/categories?Filters=[{Property:"CategoryName",Value:"${searchText}"}]`
        )
        .then(res => {
          return res.data.Data;
        });
    } else {
      return $http.get(`${MyConstant.ApiUrl}product/categories`).then(res => {
        return res.data.Data;
      });
    }
  };
  $scope.searchTextChange = searchText => {};

  $scope.selectOne = item => {
    $scope.BrowsModel = item;
    $scope.save();
  };

  $scope.save = () => {
    ctrl.onSave({ data: $scope.BrowsModel });
  };

  $scope.cancel = () => {
    ctrl.onCancel();
  };
}



// WEBPACK FOOTER //
// ./src/components/browsCategory/browsCategory.component.ts